import React from 'react';



function Certificates() {
  return (
    <div className="page-content">
        <h2>Certificates</h2>
        <h4><a href='https://www.linkedin.com/in/bartlomiej-baranski-bartbaranski/details/certifications/'>Credentials</a></h4>

        <div className='cur-cert'>
          <h2>Currently enrolled course</h2>
          <div className='position-cur-cert'>
          <p className='title-cert'>Machine Learning Specialization</p>
          <p className='org-cert'>STANFORD UNIVERSITY, DEEPLEARNING.AI</p>
          </div>
        </div>

        <div className='certificates-grid'>
        <div className='position-cert'>
            <p className='title-cert'>IBM Data Science</p>
            <p className='org-cert'>IBM</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>Meta Data Analyst</p>
            <p className='org-cert'>Meta</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>IBM Data Engineering</p>
            <p className='org-cert'>IBM</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>IBM Data Analytics with Excel and R</p>
            <p className='org-cert'>IBM</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>AWS Fundamentals</p>
            <p className='org-cert'>Amazon Web Services</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>Introduction to MongoDB</p>
            <p className='org-cert'>MongoDB</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>MongoDB Python Developer Path</p>
            <p className='org-cert'>MongoDB</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>Generative AI with Diffusion Models</p>
            <p className='org-cert'>NVIDIA Deep Learning Institute</p>
        </div>

        <div className='position-cert'>
            <p className='title-cert'>First Certificate in English - FCE</p>
            <p className='org-cert'>Cambridge Assessment English</p>
        </div>
        </div>


    </div>
      
  );
}

export default Certificates;
